"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributionAdjustSecretTokenResponseSchema = exports.CreateAdjustAttributionEventQuerySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
// We are more lenient for these externally defined schemas, in case they add fields etc
exports.CreateAdjustAttributionEventQuerySchema = typebox_1.Type.Object({
    id: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    name: typebox_1.Type.String(),
    secureToken: ruby_1.AttributionSecretKeySchema,
    compositeTrackerString: typebox_1.Type.String(),
    revenue: typebox_1.Type.Optional(typebox_1.Type.String()),
    currency: typebox_1.Type.Optional(typebox_1.Type.String()),
    eventTimeEpoch: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    eventToken: typebox_1.Type.Optional(typebox_1.Type.String()),
    eventName: typebox_1.Type.Optional(typebox_1.Type.String()),
    installTimeEpoch: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    clickTimeEpoch: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    keyword: typebox_1.Type.Optional(typebox_1.Type.String()),
    adGroupId: typebox_1.Type.Optional(typebox_1.Type.String()),
    deviceId: typebox_1.Type.Optional(typebox_1.Type.String()),
    idfa: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.AttributionAdjustSecretTokenResponseSchema = (0, core_1.StrictObject)({
    secureToken: ruby_1.AttributionSecretKeySchema,
});
